import {
  MarkChallengeCompleteAction,
  SetIsTimerRunningAction,
} from "../actions/courseActions"
import {
  COURSE_SET_TIMER_IS_RUNNING,
  COURSE_MARK_CHALLENGE_COMPLETE,
  RESET_COURSES_STATE,
} from "../actions/types"

interface CourseState {
  isTimerRunning: boolean
  challengeCompleteByCourseId: Record<string, boolean>
}

const INITIAL_STATE: CourseState = {
  isTimerRunning: true,
  challengeCompleteByCourseId: {},
}

type CourseAction =
  | SetIsTimerRunningAction
  | MarkChallengeCompleteAction
  | { type: typeof RESET_COURSES_STATE }

export default (state = INITIAL_STATE, action: CourseAction): CourseState => {
  switch (action.type) {
    case COURSE_SET_TIMER_IS_RUNNING:
      return { ...state, isTimerRunning: action.payload }

    case COURSE_MARK_CHALLENGE_COMPLETE:
      return {
        ...state,
        challengeCompleteByCourseId: {
          ...(state.challengeCompleteByCourseId ?? {}),
          [action.payload]: true,
        },
      }

    case RESET_COURSES_STATE:
      return INITIAL_STATE

    default:
      return state
  }
}
